
//Dependencies
import React, { Component } from 'react';
import {  animateScroll as scroll  } from 'react-scroll'

//material-ui
import MomentUtils from '@date-io/moment';
import "moment/locale/es";
import { withRouter } from 'react-router-dom';
import { MuiPickersUtilsProvider, InlineDatePicker } from 'material-ui-pickers';
import { valInputText, onPasteText, onPasteNum, valInputNum, valEmailText } from '../../../utils/validate.js'

  
//material-ui
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import axios from 'axios';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContentWrapper from './../../Global/SnackbarContentWrapper';
import {  DatePicker } from 'material-ui-pickers';
import { MuiThemeProvider } from "@material-ui/core";
import moment from 'moment';
import Collapse from '@material-ui/core/Collapse';
import { ValidatorForm, TextValidator,SelectValidator  } from 'react-material-ui-form-validator';
import { ClipLoader } from 'react-spinners';
import Fade from '@material-ui/core/Fade';

//images
import corazonSvg from '../../../static/svg/round-favorite-border-24-px.svg';
import maletinSvg from '../../../static/svg/round-work-outline-24-px.svg';
import personaSvg from '../../../static/svg/round-account-circle-24-px.svg';
import dniSvg from '../../../static/svg/identity-card.svg';
import cuilSvg from '../../../static/svg/round-library-books-24-px.svg';
import generoSvg from '../../../static/svg/round-wc-24-px.svg';
import calendarioSvg from '../../../static/svg/round-date-range-24-px.svg';

//plazofijo
import PlazoFijoSelect from '../common/components/PlazoFijoSelect'
import ProxyRequester from '../common/comunication/ProxyRequester'


// persistencia en redux
import { connect } from 'react-redux';
import { 
    setInformacionPersonal,
    setValueInformacionPersonal,
    setIdAndTextInformacionPersonal,
    setDatosNacimiento,
    removeDataConyuge
} from '../../../actions/actions';

class InformacionPersonal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ejemplar: [],
            tipo: "",
            telefonoMovil: "",
            provincias: [],
            provincia: '',
            ciudades: [],
            paisNacimiento: '',
            nacionalidad: '',
            ciudad: '',
            listaSituacionLaboral: [],
            listaEstadoCivil: [],
            nupcias:[{id:1,value:1},{id:2,value:2},{id:3,value:3},{id:4,value:4},{id:5,value:5}],
            open: false,
            showConyuge:false,
            generos:{},
            tipoTributarios:[],
            versionDocumentos:[],
            conyugeEjemplar:"",
            conyugeTipo:"",
            buscandoCiudades:false
        }

        this.conyugeFormRef = React.createRef();

        this.setItem = this.setItem.bind(this);
        this.isDataOk = this.isDataOk.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.snackbar = this.snackbar.bind(this);
        this.submitInvisible = this.submitInvisible.bind(this);
        this.handleEstadoCivil = this.handleEstadoCivil.bind(this);
        this.handleChangeOnConyuge = this.handleChangeOnConyuge.bind(this);   
        this.onChangeD = this.onChangeD.bind(this);
        this.startLoading = this.startLoading.bind(this);
        this.handleChangeDate = this.handleChangeDate.bind(this);
        this.isDataConyugeOk = this.isDataConyugeOk.bind(this);
        this.isFechaNacOk = this.isFechaNacOk.bind(this);
        this.getDataDatePickerNacimiento = this.getDataDatePickerNacimiento.bind(this);



        this.handleKeyPressText = this.handleKeyPressText.bind(this);
        this.handlePasteText = this.handlePasteText.bind(this);
        this.handleKeyPressNum = this.handleKeyPressNum.bind(this);
        this.handlePasteNum = this.handlePasteNum.bind(this);
    }


    handleKeyPressText = event => {
        if (!valInputText(event)) {
            event.preventDefault();
        }
    }

    handlePasteText = event => {
        onPasteText(event)
    }

    handleKeyPressNum = event => {
        if (!valInputNum(event)) {
            event.preventDefault();
        }
    }

    handlePasteNum = event => {
        onPasteNum(event)
    }

    handleChangeDate(event){
        this.props.setDatosNacimiento(event) 
    }

    handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        this.setState({ open: false });
    }

    snackbar = () => {
        this.setState({ open: true });
    };

    componentWillUnmount(){
        let { estadoCivil } = this.props.plazoFijoInformacionPersonal
        
        if(estadoCivil !== "C"){
            //this.props.removeDataConyuge() 
        }
    }

    componentDidMount() {

        Promise.all([ 
                    ProxyRequester.getResource(localStorage.getItem('url') + '/api/plazoFijo/catalogo/pais?vigente=true'), 
                    ProxyRequester.getResource(localStorage.getItem('url') + '/api/plazoFijo/catalogo/provincias?vigente=true&idPais=80'), 
                    ProxyRequester.getResource(localStorage.getItem('url') + '/api/plazoFijo/situacionLaboral'),
                    ProxyRequester.getResource(localStorage.getItem('url') + '/api/plazoFijo/catalogo/estadosCiviles')
                ])
            .then(  responses  => {

                this.setState({
                    ejemplar: responses[0].data,
                    provincias: responses[1].data,
                    listaSituacionLaboral: responses[2].data,
                    listaEstadoCivil: responses[3].data,
                    //showConyuge : this.props.plazoFijoInformacionPersonal.estadoCivil === "C"
                    showConyuge : false
                });

                let {paisNacimiento,nacionalidad} = this.props.plazoFijoInformacionPersonal

                if( paisNacimiento === ""){
                    paisNacimiento = 80 //argentina por default
                }
                if( nacionalidad === ""){
                    nacionalidad = 80
                }

                this.props.setInformacionPersonal({
                    paisNacimiento,
                    nacionalidad
                })
            })
            //cargo datos para una eventual carga de datos de conyuge
            .then( () => ProxyRequester.getResource(localStorage.getItem('url') + '/api/plazoFijo/inicializarDatosBasicos') )

            .then( datosBasicos => {
                this.setState({
                    generos:datosBasicos.data.generos,
                    tipoTributarios:datosBasicos.data.tipoTributarios,
                    versionDocumentos:datosBasicos.data.versionDocumentos
                })        
            })
    }

    forceSubmit(){
        this.conyugeFormRef.submit()
    }

    handleChangeOnConyuge(e){
        console.log(e)
    }

    setItem(event){
        let name = event.target.name
        let value = event.target.value
        
        value = (typeof value === "string")?value.trim():value
        this.props.setValueInformacionPersonal({
            fieldName:name,
            fieldValue:value
        }) 

        if( name === 'telefonoMovil' ){
            this.setState({ telefonoMovil: value });
        }

        if ( name === "dniConyuge" ){ 
            let {apellidoConyuge} = this.props.plazoFijoInformacionPersonal

            if(apellidoConyuge !== "" && ( value.length == 7 || value.length == 8)) {
                axios.get(localStorage.getItem('url') + '/api/plazoFijo/obtenerCuil?dni=' + value + '&apYNom=' + apellidoConyuge,{withCredentials: true})
                .then((response) => {

                    let idTributario = ( response.data.toString().length == 0 )?"":response.data.toString()

                    if(idTributario !== ""){
                        this.props.setValueInformacionPersonal({
                            fieldName:"cuilConyuge",
                            fieldValue:idTributario
                        })
                    }

                }).catch((err) => {
                    this.props.history.push('/plazo-fijo/PF-fail');
                });
            }
        }
    }

    getDataDatePickerNacimiento(){
        let data = {
            errorFechaNac:false,
            errorMessageFechaNac:""
        }

        let { fechaNac } = this.props.plazoFijoInformacionPersonal

        if( this.props.externalSubmitted && ( fechaNac === null || fechaNac === "" ) ){
            data.errorFechaNac = true
            data.errorMessageFechaNac = "Campo requerido"
            return data
        }

        if( fechaNac === null ){
            //initial state
            return data
        }

        if( fechaNac === ""){
            data.errorFechaNac = true
            data.errorMessageFechaNac = "Campo requerido"
            return data
        }

        let validFormat = moment(fechaNac, 'DD/MM/YYYY', true).isValid();

        let fechaNacMoment =  moment(fechaNac,'DD/MM/YYYY')

        if  ( !validFormat  ){
            data.errorFechaNac = true
            data.errorMessageFechaNac = "Fecha invalida"

        } else if  ( fechaNacMoment.isAfter(moment()) ){
            data.errorFechaNac = true
            data.errorMessageFechaNac = "Fecha invalida"

        } else if (fechaNacMoment.isAfter(moment().add(-18, 'year'))){
            data.errorFechaNac = true
            data.errorMessageFechaNac = "Debe ser mayor de 18 años"
        
        } else if ( fechaNacMoment.isBefore(moment().add(-100, 'year')) ){
            data.errorFechaNac = true
            data.errorMessageFechaNac = "Fecha invalida"
        }

        return data
    }

    isFechaNacOk(){
        return !this.getDataDatePickerNacimiento().errorFechaNac
    }

    isDataConyugeOk(){
        let { 
            estadoCivil,
            nombreConyuge,
            apellidoConyuge,
            dniConyuge,
            cuilConyuge,
            tipoConyuge,
            ejemplarConyuge,
            generoConyuge,
            nupcias
        } = this.props.plazoFijoInformacionPersonal

        return true
        
        if( estadoCivil !== "C"){
            return true
        }

        let nupciasOk = nupcias >= 1 && nupcias <=5
        let nombreOk = !!nombreConyuge === true && isNaN(nombreConyuge) && nombreConyuge.length >= 1 && nombreConyuge.length <= 64
        let apellidoOk = !!apellidoConyuge === true && isNaN(apellidoConyuge) && apellidoConyuge.length >= 1 && apellidoConyuge.length <= 64                        
        let ejemplarTipoDniOk = !!tipoConyuge === true && !!ejemplarConyuge === true && !!generoConyuge === true 
        let dniOk = !!dniConyuge === true && !isNaN(dniConyuge) && dniConyuge.length >= 7 && dniConyuge.length <= 8
        let cuilOk = !!cuilConyuge === true && !isNaN(cuilConyuge) && cuilConyuge.length === 11
        
        return nupciasOk && nombreOk && apellidoOk && ejemplarTipoDniOk && dniOk && cuilOk
    }

    isDataOk(){
        let { plazoFijoInformacionPersonal } = this.props
        let isOk = true
        
        let valuesToCheck = ["tipo","paisNacimiento","nacionalidad","estadoCivil"]

        valuesToCheck.forEach((item, index) => {
            if( !!plazoFijoInformacionPersonal[item] === false ){
                isOk = false
            }
        })

        return isOk && this.isFechaNacOk() && this.isDataConyugeOk()
    }

    submitInvisible(){
        console.log("submitInvisible")
    }

    handleEstadoCivil(event){
        let { value } = event.target
        /*if( value == "C"){

            this.setState({showConyuge:true})
            scroll.scrollMore(300, {delay:100})
            
        }else{
            this.setState({showConyuge:false})      
        }*/
        
        this.props.setValueInformacionPersonal({
            fieldName:"estadoCivil",
            fieldValue:value
        }) 
    }

    startLoading(){
        return new Promise( (resolve,reject) =>{
            this.setState({buscandoCiudades:true})
            setTimeout( () => {
                resolve("string de prueba");
            },500)
        })
    }

    onChangeD = (selectedBook) => {
        this.props.setIdAndTextInformacionPersonal(selectedBook) 
    }

    render() {      
        const {plazoFijoInformacionPersonal ,classes} = this.props;
        let displayNupcias = this.state.showConyuge ? "block": "none"
        //let displayNupcias = "none"

        let {errorFechaNac,errorMessageFechaNac} = this.getDataDatePickerNacimiento()

        return (
            <div className="ip">
                <div className="ip-container">
                    <Grid container >
                        <Grid item xs={12} md={12}>

                                <Grid container spacing={8} >

                                    <Grid item xs={1} className={classes.svgCenter}>
                                        <svg width="26px" height="26px" viewBox="0 0 26 26">
                                            <g id="MVP-SALIDA-Wireframes" stroke="none" fill="none">
                                                <g id="wizard-2_PlazoFijo" transform="translate(-239.000000, -300.000000)" fill="#B2B2B2">
                                                    <g id="round-public-24px" transform="translate(239.000000, 300.000000)">
                                                        <path d="M13,0.5 C6.1,0.5 0.5,6.1 0.5,13 C0.5,19.9 6.1,25.5 13,25.5 C19.9,25.5 25.5,19.9 25.5,13 C25.5,6.1 19.9,0.5 13,0.5 Z M11.75,22.9125 C6.8125,22.3 3,18.1 3,13 C3,12.225 3.1,11.4875 3.2625,10.7625 L9.25,16.75 L9.25,18 C9.25,19.375 10.375,20.5 11.75,20.5 L11.75,22.9125 Z M20.375,19.7375 C20.05,18.725 19.125,18 18,18 L16.75,18 L16.75,14.25 C16.75,13.5625 16.1875,13 15.5,13 L8,13 L8,10.5 L10.5,10.5 C11.1875,10.5 11.75,9.9375 11.75,9.25 L11.75,6.75 L14.25,6.75 C15.625,6.75 16.75,5.625 16.75,4.25 L16.75,3.7375 C20.4125,5.225 23,8.8125 23,13 C23,15.6 22,17.9625 20.375,19.7375 Z" id="Shape"></path>
                                                    </g>
                                                </g>
                                            </g>
                                        </svg>
                                    </Grid>
                                    <Grid item xs={11} md={5} >

                                        <PlazoFijoSelect values={this.state.ejemplar}
                                            label={"País de nacimiento"}
                                            name={"paisNacimiento"}
                                            value={ plazoFijoInformacionPersonal.paisNacimiento }
                                            keyValue={"descripcion"}
                                            errorMessage={"Debe seleccionar un país de nacimiento"}
                                            externalSubmitted={this.props.externalSubmitted}   
                                            setItem={this.onChangeD}  
                                            placeholder={"País de nacimiento *"}      
                                            >
                                        </PlazoFijoSelect> 
                                        
                                    </Grid>
                                    <Grid item xs={11} md={5} className={classes.marginGrid}>

                                        <PlazoFijoSelect values={this.state.ejemplar}
                                            label={"Nacionalidad"}
                                            name={"nacionalidad"}
                                            value={plazoFijoInformacionPersonal.nacionalidad}
                                            keyValue={"nacionalidad"}
                                            errorMessage={"Debe seleccionar una nacionalidad"}
                                            externalSubmitted={this.props.externalSubmitted}   
                                            setItem={this.onChangeD}  
                                            placeholder={"Nacionalidad *"}   
                                            >
                                        </PlazoFijoSelect> 

                                    </Grid>
                                </Grid>
                                <Grid container spacing={8} >
                                    <Grid item xs={1} className={classes.svgCenter}>
                                        <img src={calendarioSvg}  />
                                    </Grid>
                                    <Grid item xs={11} md={5}  >
                                        <MuiPickersUtilsProvider
                                            utils={MomentUtils}
                                            locale={this.state.locale}
                                            moment={moment}
                                            >                                       
                                            <MuiThemeProvider>
                                                <InlineDatePicker
                                                    placeholder="Fecha de nacimiento"  
                                                    fullWidth
                                                    keyboard
                                                    invalidDateMessage="El formato de la fecha es inválida"
                                                    invalidLabel="El formato de la fecha es inválida"
                                                    format="DD/MM/YYYY"
                                                    value={ plazoFijoInformacionPersonal.fechaNacMoment }
                                                    onChange={this.handleChangeDate}
                                                    error={errorFechaNac}
                                                    helperText={errorMessageFechaNac}
                                                    maxDate={  moment()}  //maxDate
                                                    placeholder={"dd/mm/aaaa"}      
                                                    label={"Fecha de Nacimiento"}   
                                                    mask={value =>
                                                        value
                                                            ? [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/]
                                                            : []
                                                    }   
                                                />

                                                 
                                            </MuiThemeProvider>
                                        </MuiPickersUtilsProvider>
                                    </Grid>

                                    <Grid item xs={1} className={classes.svgCenter}>
                                        <img src={maletinSvg}  />
                                    </Grid>
                                    <Grid item xs={11} md={5} >
                                        <PlazoFijoSelect values={this.state.listaSituacionLaboral}
                                                        label={"Situación laboral"}
                                                        name={"tipo"}
                                                        value={plazoFijoInformacionPersonal.tipo}
                                                        keyValue={"descripcion"}
                                                        errorMessage={"Debe seleccionar su situación laboral"}
                                                        externalSubmitted={this.props.externalSubmitted}   
                                                        setItem={this.onChangeD}  >
                                        </PlazoFijoSelect> 
                                    </Grid>
                                </Grid>

                                <Grid container spacing={8}>
                                    <Grid item xs={1} className={classes.svgCenter}>
                                        <img src={corazonSvg}  />
                                    </Grid>
                                    
                                    <Grid item xs={11} md={5}>
                                        <PlazoFijoSelect values={this.state.listaEstadoCivil}
                                                        label={"Estado civil"}
                                                        name={"estadoCivil"}
                                                        value={plazoFijoInformacionPersonal.estadoCivil}
                                                        keyValue={"descripcion"}
                                                        errorMessage={"Debe seleccionar un estado civil"}
                                                        externalSubmitted={this.props.externalSubmitted}   
                                                        setItem={this.handleEstadoCivil}  >
                                        </PlazoFijoSelect>                                  
                                    </Grid>

                                    <Grid style={{display:displayNupcias}} item xs={1} className={classes.svgCenter}>
                                        <img src={corazonSvg}  />
                                    </Grid>
                                    <Grid style={{display:displayNupcias}} item xs={11} md={5}>
                                        <PlazoFijoSelect values={this.state.nupcias}
                                                        label={"Nupcias"}
                                                        name={"nupcias"}
                                                        value={plazoFijoInformacionPersonal.nupcias}
                                                        keyValue={"value"}
                                                        errorMessage={"Debe seleccionar nupcias"}
                                                        externalSubmitted={this.props.externalSubmitted}   
                                                        setItem={this.onChangeD}  >
                                        </PlazoFijoSelect>                                  
                                    </Grid>
    
                                </Grid>
                        </Grid>

                        <Grid item xs={12} className={classes.conyugeBox}>
                        
                            <Collapse timeout={1000} in={this.state.showConyuge}>
                                <Grid container spacing={8}>
                                    <Grid item xs={12} md={6} className="ip-title">
                                        Datos de tu cónyuge
                                    </Grid>
                                </Grid>

                                <Grid container spacing={8} >
                                    
                                    <Grid item xs={12} >
                                        <ValidatorForm
                                            ref={(r) => { this.conyugeFormRef = r; }}
                                            onSubmit={this.submitInvisible}
                                            onError={errors => this.snackbar()}
                                        >
                                            <Grid container spacing={8} >
                                                <Grid item xs={1} className={classes.svgCenter}>
                                                    <img src={personaSvg}  />
                                                </Grid>
                                                <Grid item xs={11} md={5} >
                                                    <TextValidator
                                                        validators={['required', 'isString', 'maxStringLength:64', 'minStringLength:1']}
                                                        errorMessages={['Nombre es requerido', 'Caracter inválido', "Maximo 64 caracteres"]}
                                                        fullWidth
                                                        className="input-container"
                                                        onChange={this.setItem}
                                                        value={plazoFijoInformacionPersonal.nombreConyuge}
                                                        id="nombre"
                                                        label="Nombre"
                                                        name="nombreConyuge"
                                                        onKeyPress={this.handleKeyPressText}
                                                        onPaste={this.handlePasteTex}
                                                    />
                                                </Grid>
                                                <Grid item xs={11} md={5} className={classes.marginGrid}>
                                                    <TextValidator
                                                        validators={['required', 'isString', 'maxStringLength:64', 'minStringLength:1']}
                                                        errorMessages={['Apellido es requerido', 'Caracter inválido', "Maximo 64 caracteres"]}
                                                        fullWidth
                                                        className="input-container"
                                                        onChange={this.setItem}
                                                        value={plazoFijoInformacionPersonal.apellidoConyuge}
                                                        id="apellido"
                                                        label="Apellido"
                                                        name="apellidoConyuge"
                                                        onKeyPress={this.handleKeyPressText}
                                                        onPaste={this.handlePasteTex}
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid container spacing={8} >
                                                <Grid item xs={1} className={classes.svgCenter}>
                                                    <img src={dniSvg}  />
                                                </Grid>
                                                <Grid item xs={11} md={5} >
                                                    <TextValidator
                                                        fullWidth
                                                        className="input-container"
                                                        onChange={this.setItem}
                                                        value={plazoFijoInformacionPersonal.dniConyuge}
                                                        id="dni"
                                                        label="DNI"
                                                        name="dniConyuge"
                                                        validators={['required', 'isNumber', 'maxStringLength:8', 'minStringLength:7' ]}
                                                        errorMessages={['DNI requerido', 'DNI inválido', "Maximo 8 caracteres", "Minimo 7 caracteres" ]}
                                                        onKeyPress={this.handleKeyPressNum}
                                                    />
                                                </Grid>
                                                <Grid item xs={11} md={5} className={classes.marginGrid}>

                                                    <FormControl fullWidth>
                                                        <SelectValidator
                                                            
                                                            label="Ejemplar"
                                                            validators={['required']}
                                                            errorMessages={['Ejemplar requerido']}
                                                            onChange={this.setItem}
                                                            value={plazoFijoInformacionPersonal.ejemplarConyuge}
                                                            inputProps={{
                                                                id: 'conyugeEjemplar',
                                                                name: 'ejemplarConyuge'
                                                            }}
                                                        >
                                                            {
                                                                this.state.versionDocumentos.map((versionDocumento, key) => (
                                                                    <MenuItem key={key} value={versionDocumento.id}>
                                                                        {versionDocumento.descripcion}
                                                                    </MenuItem>
                                                                ))
                                                            }
                                                        }
                                                        </SelectValidator>
                                                    </FormControl>

                                                </Grid>
                                            </Grid>
                                            <Grid container spacing={8}>
                                                <Grid item xs={1} className={classes.svgCenter}>
                                                    <img src={cuilSvg}  />
                                                </Grid>
                                                <Grid item xs={11} md={5} >
                                                    <TextValidator
                                                        fullWidth
                                                        className="input-container"
                                                        onChange={this.setItem}
                                                        value={plazoFijoInformacionPersonal.cuilConyuge}
                                                        id="idTributario"
                                                        label="CUIL/CUIT"
                                                        name="cuilConyuge"
                                                        validators={['required', 'isNumber', 'maxStringLength:11', 'minStringLength:11']}
                                                        errorMessages={['CUIL/CUIT requerido', 'CUIL/CUIT inválido', "Maximo 11 caracteres", "Minimo 11 caracteres"]}
                                                    />
                                                </Grid>
                                                <Grid item xs={11} md={5} className={classes.marginGrid}>
                                                     <FormControl style={{width:"100%"}}>
                                                        <SelectValidator
                                                            label="Tipo"
                                                            validators={['required']}
                                                            errorMessages={['Tipo requerido']}
                                                            onChange={this.setItem}
                                                            value={plazoFijoInformacionPersonal.tipoConyuge}
                                                            inputProps={{
                                                                id: 'conyugeTipo',
                                                                name: 'tipoConyuge'
                                                            }}
                                                        >
                                                            {
                                                                this.state.tipoTributarios.map((tipoTributario, key) => (
                                                                    <MenuItem key={key} value={tipoTributario.id}>
                                                                        {tipoTributario.descripcion}
                                                                    </MenuItem>
                                                                ))
                                                            }
                                                        }
                                                        </SelectValidator>
                                                    </FormControl>
                                                </Grid>
                                            </Grid>

                                            <Grid container spacing={8}>
                                                <Grid item xs={1} className={classes.svgCenter}>
                                                    <img src={generoSvg}  />
                                                </Grid>
                                                <Grid item xs={11} md={5} >
                                                    <FormControl fullWidth>
                                                        <SelectValidator
                                                            
                                                            label="Género"
                                                            validators={['required']}
                                                            errorMessages={['Género requerido']}
                                                            onChange={this.setItem}
                                                            value={plazoFijoInformacionPersonal.generoConyuge}
                                                            inputProps={{
                                                                id: 'genero',
                                                                name: 'generoConyuge'
                                                            }}
                                                        >
                                                            {
                                                                Object.keys(this.state.generos).map((genero, key) => (
                                                                    <MenuItem key={key} value={genero}>
                                                                        {this.state.generos[genero]}
                                                                    </MenuItem>
                                                                ))
                                                            }
                                                        }
                                                        </SelectValidator>
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </ValidatorForm>
                                    </Grid>
                                    
                                </Grid>
                            </Collapse>
                        </Grid>
                    </Grid>
                    <Snackbar
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                        open={this.state.open}
                        autoHideDuration={3000}
                        onClose={this.handleClose}
                    >
                        <SnackbarContentWrapper
                            onClose={this.handleClose}
                            variant="error"
                            message="Revisá los campos en rojo."
                        />
                    </Snackbar>
                </div>
            </div >
        );
    }
}

const styles = {
    root: {
        flexGrow: 1,
    },
    conyugeBox:{
        marginTop:"25px"
    },
    marginGrid: {
        marginLeft: "8% !important"
    },
    verticalCenterCalendar: {
        paddingTop:"20px !important"
    },
    svgCenter: {
        display: "block",
        marginTop: "2% !important",
        textAlign: "center"
    },
    svgCenterRight: {
        display: "block",
        marginBottom: "1% !important",
        textAlign: "left"
    },
    '@media  screen and (max-width: 959px)': {
        phoneSvgLeft: {
            textAlign: "center !important"
        }
    },
    '@media  screen and (max-width: 800px)': {
        svgCenterRight: {
            marginBottom: "4% !important"
        }
    }
};

const mapStateToProps = (state) => {
    return ({
        plazoFijoInformacionPersonal: state.plazoFijoInformacionPersonal,
        primerFormulario: state.plazoFijoPrimerFormulario,
        estadoLocal: 'INFORMACION_PERSONAL'
    });
}

const mapDispatchToProps = {
    setInformacionPersonal,
    setValueInformacionPersonal,
    setIdAndTextInformacionPersonal,
    setDatosNacimiento,
    removeDataConyuge
}

export default connect(mapStateToProps, 
                        mapDispatchToProps, 
                        null, 
                        { withRef: true }) 
                        (  withRouter(withStyles(styles) ( InformacionPersonal)) ) ;



// WEBPACK FOOTER //
// ./src/components/PlazoFijo/datosPersonales/InformacionPersonal.js